import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=6d1c8993&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=6d1c8993&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1c8993",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d1c8993')) {
      api.createRecord('6d1c8993', component.options)
    } else {
      api.reload('6d1c8993', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=6d1c8993&scoped=true", function () {
      api.rerender('6d1c8993', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operation/detail.vue"
export default component.exports